module.exports = __webpack_public_path__ + "static/media/left-bottom-background.741f4f63.png";